/* eslint-disable import/prefer-default-export */
export { default as IfComponent } from './ifComponent';
